/**
 * Global Imports
*/

import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

/**
 * Root Imports
*/

import { TokenStorage } from '~/util';
import { UserContext } from '~/components/Authenticator';

/**
 * Exports
*/

/**
 * 
 */
export function Logout(props) {
  /** Contexts **/

  const user = useContext(UserContext);

  /** Side-Effects **/

  useEffect(() => {
    return handleUnmount;
  }, []);

  /** Event Handlers **/

  /**
   * 
   */
  const handleUnmount = () => {
    user.clearToken();
    TokenStorage.clear();
  };

  /** Output **/

  return <Redirect to='/' />;
}